import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// ngrx store
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
// models
import { AppState } from '../../models/app-state.interface';
// services
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { AppStateService } from '../../../shared/services/app-state.service';
import { BookingService } from '../../services/booking.service';
import { panelSet } from 'app/booking/reducers/panel.reducer';
import { resetBookingReferenceState, updateBookingPaid } from 'app/booking/reducers/booking.actions';
import { resetD2dState } from 'app/booking/reducers/d2d-booking.reducer';
import { resetUtilityReducer } from '@shared/reducers/utility.actions';
import { decrementCurrentStep } from 'app/booking/reducers/flyback.reducer';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

declare var exponea: any;

@Component({
  selector: 'app-flyback-flight-confirmation',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './flyback-flight-confirmation.component.html',
  styleUrls: ['./flyback-flight-confirmation.component.scss']
})
export class FlybackFlightConfirmationComponent implements OnInit {
  @Input() copyLoaded;
  @Input() appCopy;
  @Input() appAirportCopy;
  @Input() selectedLanguage;
  @Input() languageCode;

  @Input() showFlyBackSection;
  @Input() flightData;

  public originalPrice;
  public discountedPrice;
  public selectedFlight;
  public flightDirection = 1;
  public arrivalAirport;

  constructor(
    private _appStore: Store<AppState>,
    private _dataStorageService: DataStorageService,
    private _router: Router,
    private _appStateService: AppStateService,
    private _bookingService: BookingService,
  ) { }

  ngOnInit(): void {


    this.arrivalAirport = this.flightData.flightStatusDetails[0].departureAirport;

    const state = this.getState(this._appStore);
    this.flightDirection = state.bookingReducer.bookingDetails.journeyLegDetails[0].journeyDirection;

    this.selectedFlight = state.flightReducer.flightDetails.flightResponse;

    this.setZonePrice(state);

  }

  setZonePrice(state) {
    const flybackRducer = state.flybackReducer;

    let minPrice = flybackRducer.inboundPrice;
    const minPostOfficePrice = flybackRducer.departurePostOfficePrice;
    const minAddressPrice = flybackRducer.outboundPrice;

    if (this.flightDirection === 1) {
      minPrice = this.extractNumbers(minPostOfficePrice)[0] < this.extractNumbers(minAddressPrice)[0] ? minPostOfficePrice : minAddressPrice;
    }

    this.originalPrice = minPrice;

    const minAmount = this.extractNumbers(minPrice);
    const currencySymbol = minPrice.split(`${minAmount}`)[0];
    const discount = (10 * this.extractNumbers(minPrice)[0]) / 100;

    const discountedPrice = Number(minAmount) - discount;

    this.discountedPrice = `${currencySymbol}${discountedPrice}`;
  }

  extractNumbers(str) {
    const result = str.match(/\d+/g);
    return result ? result.map(Number) : [];
  }

  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }


  confirmSelectedFlight() {
    let serviceURL = this.flightDirection === 1 ? '/abc/collection-location' : '/ccd/delivery-location';

    // reset every thing
    this._appStateService.resetCurrentBookingData();
    this._appStateService.resetPanelNumber();
    this._appStateService.resetTimeslotData();
    this._appStateService.resetHubDropReducer();
    this._appStateService.resetMilesData();
    this._appStateService.resetPriceData();
    this._appStateService.resetUpsellbookingReducer();

    this._bookingService.resetForFlyback();

    // reset reducers
    this._appStore.dispatch(resetUtilityReducer());
    this._appStore.dispatch(resetD2dState());

    this._appStore.dispatch(resetBookingReferenceState());
    this._appStore.dispatch(updateBookingPaid({payload: false }));

    this._appStore.dispatch(panelSet({ payload: 1 }));

    exponea.track('flyback_book_now', {});

    // save and then redirect
    this._dataStorageService.saveDataPromise().then(() => {
      window.location.pathname = serviceURL;
    });

  }

  returnToPreviouseStep() {
    exponea.track('flyback_edit', {});

    this._appStore.dispatch(decrementCurrentStep());
    this._dataStorageService.saveData();
  }

}
